const cloneAndSort = (urlSearchParams: URLSearchParams) => {
  const clone = new URLSearchParams(urlSearchParams);
  clone.sort();
  return clone;
};

export const areURLSearchParamsEqual = (params1: URLSearchParams, params2: URLSearchParams) =>
  params1.toString() === params2.toString() ||
  cloneAndSort(params1).toString() === cloneAndSort(params2).toString();
